import { render, staticRenderFns } from "./PassagesCoureur.vue?vue&type=template&id=3e5164d7&scoped=true&"
import script from "./PassagesCoureur.vue?vue&type=script&lang=js&"
export * from "./PassagesCoureur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5164d7",
  null
  
)

export default component.exports